import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router";
import React, {useEffect, useState} from "react";
import {Day} from "../core/Day";
import {getBoardById} from "../helper_functions";
import {MAIN_BACKGROUND_COLOR} from "../CONSTANTS";
import SelectedBoard from "../main/SelectedBoard";

export function BoardPage(){
    const { board: boardId, year: selectedYear } = useParams();

    const navigate = useNavigate();

    const [day, setDay] = useState<Day | null>(null);

    useEffect(() => {

        if(boardId == null){
            navigate(`/`);
        }


    }, [boardId]);

    const [board, setBoard] = useState(getBoardById(boardId ?? ""));

    if(board === null)
    {
        navigate(`/`);
        return (<p>Board not found.</p>);
    }

    const reloadBoard = () => {
        setBoard(getBoardById(boardId ?? ""));
    }

    return (
        <Box sx={{
            display: 'flex',
            height: '100dvh',
            width: '100dvw',
            backgroundColor: MAIN_BACKGROUND_COLOR
        }}>
            <SelectedBoard
                {...board}
                selectedYear={selectedYear ? parseInt(selectedYear) : 2025}
                options={{
                    sx: {  m: 'auto', p:0, mt: '16px', width: 'calc(100% - 32px)', height: 'calc(100% - 32px)', borderRadius: 8 }
                }}
                reloadBoard={reloadBoard}
            />
            {/*<Paper sx={{ m: 'auto', mt: '16px', width: 'calc(100% - 32px)', height: 'calc(100% - 32px)', borderRadius: 8 }}>*/}
            {/*    /!*<Typography>X</Typography>*!/*/}
            {/*</Paper>*/}
        </Box>
    )

}